import React from 'react';
import { map, isEmpty, filter } from 'lodash';
import { Tag, Popover, Typography } from 'antd';
import classNames from 'classnames'
const {Link} = Typography;
export const CWE = (values = [], className = "") => {
    if (typeof values === "string") {
        values = [values];
    }
    values = filter(values, (text, i) => {
        if (text === 0 || text === '0') {
            return false;
        } else if (!text) {
            return false
        } else { 
            return true;
        }
    })
    if (isEmpty(values)) {
        return "N/A";
    }
    const resorces = values.slice();
    const minResources = resorces.splice(0, 2);
    let content = null;
    
    if (resorces.length) {
        content = (
            <div style={{ maxHeight: 150, maxWidth: 200, overflow: "auto" }}>
                {
                    map(values, (text, i) => <Tag style={{ marginRight: 2, marginBottom: 2 }} className={className} key={`${text}-${i}`}><Link target="_blank" href={`https://cwe.mitre.org/data/definitions/${text.replace("CWE-", "")}.html`}>{text}</Link></Tag>)
                }
            </div>
        )
    }
    return (
        <div>
            {
                map(minResources, (text, i) =>  
                    <a rel="noopener noreferrer" key={`${text}-${i}`} target="_blank" href={`https://cwe.mitre.org/data/definitions/${text.replace("CWE-", "")}.html`} style={{ verticalAlign: 'middle', display: 'inline-block' }}>
                        <Tag title={text} className={classNames("text-ellipsis tools", className)} style={{ marginRight: 2, verticalAlign: 'inherit', fontSize: 13 }}>{text}</Tag>
                    </a>)
            }
            {
                resorces.length
                    ?
                    <Popover trigger="click" content={content}>
                        <Typography.Link size="small" type="link" style={{ fontSize: 12 }}>+{resorces.length}</Typography.Link>
                    </Popover>
                    :
                    null
            }
        </div>
    )
}